import type { IScoreProgressionState } from '@/store/modules/report/score-progression/types';

export const state: IScoreProgressionState = {
  chart: null,
  table: null,
};
